import {
  getOnNavigation,
  getOnNavigationCategory,
} from '@/common/converter/utils/get-event-property'
import { isElementTypeCategory } from '@/common/converter/utils/element'
import { restEventCommonParams } from '@/common/converter/const'

/**
 * convert event 'on-navigation'
 * @param elementList
 * @returns {{type: string, url: string, method: string, bodylist: [], add_common_params: string, add_timestamp: string, add_credential: string}|undefined}
 */
export const convertEventOnNavigation = (elementList = []) => {
  // category 의 경우 cell level 이 아니라 context action list 가 아닌 action list 를 참조 해야함
  const isCategory = elementList?.some(isElementTypeCategory) ?? false

  const { type, url, method, bodyList, isRender, toastText, cta } = isCategory
    ? getOnNavigationCategory(elementList)
    : getOnNavigation(elementList)

  if (!isRender) return undefined

  return {
    type,
    url,
    method,
    cta,
    bodylist: bodyList,
    toast_text: toastText,
    ...restEventCommonParams,
  }
}
